import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { ProjectSelect } from './ProjectSelect'

export const projectContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.project.projectSelect).to(ProjectSelect)
})
